// extracted by mini-css-extract-plugin
export var content = "_r4-1";
export var noScroll = "_r4-3";
export var paper = "_r4-0";
export var scrollable = "_r4-2";